<ng-container>
  <input
    class="mr-2"
    [value]="value || null"
    (input)="onInput(inputComponent.value)"
    [readOnly]="readonly"
    placeholder="{{
      placeholder || '#UI_CORE.COMPONENTS.ENTITY_QUERY_INPUT.PLACEHOLDER' | translate
    }}"
    #inputComponent
    />
  @if (strategy.loading()) {
    <i class="fa-regular fa-spinner fa-spin ml-4"></i>
  }
  @if (value?.length || strategy.loading() || inputComponent.value.length) {
    <div class="pointer order-100 ml-4">
      @if (!readonly) {
        <i
          id="closeDialog"
          class="fa-regular fa-xmark"
          (click)="onCancel(); $event.stopPropagation()"
        ></i>
      }
    </div>
  }
  @if (!strategy.loading()) {
    @if (!readonly) {
      <div
        id="openDialog"
        class="ml-4 pointer order-100"
        (click)="onOpen(); $event.stopPropagation()"
        >
        <i class="fa-regular fa-database"></i>
      </div>
    }
  }
</ng-container>
